// The V-Kit mark (design changelog 2026-10-05 «Rename to V-Kit + new mark»): drawn in the text colour
// through a CSS mask, so one file works on light and dark grounds.
export function BrandMark({ size }: { size: number }) {
  return <span className="brand-mark" role="img" aria-label="V-Kit" style={{ width: size, height: size }} />;
}
